import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from './quasar-user-options';
import i18n from './i18n';
import auth from './router/middleware/auth';
import guest from './router/middleware/guest';
import admin from './router/middleware/admin';
import { createGtm } from '@gtm-support/vue-gtm';

const app = createApp(App);
app.use(Quasar, quasarUserOptions);
app.use(i18n);
app.use(store);
app.use(router);
app.use(
    createGtm({
        id: process.env.VUE_APP_GTM_ID,
        enabled: true,
        debug: false,
        loadScript: true,
        vueRouter: router,
        trackOnNextTick: false,
    })
);

// load middleware
auth.load(router, store, i18n);
guest.load(router, store);
admin.load(router, store);

app.mount('#app');
